import { rootSaga as userSaga } from './User/index';
import { rootSaga as sessionSaga } from './Sessions/index';
import { rootSaga as webinarSaga } from './Webinars/index';
import { rootSaga as recordingSaga } from './Recordings/index';
import { rootSaga as reportSaga } from './Reports/index';
import { rootSaga as sessionDetailsSaga } from './SessionDetails/index';
import { rootSaga as recordingDetailsSaga } from './RecordingDetails/index';
import { rootSaga as sessionRegistrantsSaga } from './SessionRegistrants/index';
import { rootSaga as sessionAttendeesSaga } from './SessionAttendees/index';
import { rootSaga as sessionPollsSaga } from './SessionPoll/index';
import { rootSaga as sessionQuestionsSaga } from './SessionQuestions/index';
import { rootSaga as sessionSurveysSaga } from './SessionSurvey/index';
import { rootSaga as virtualEventsSaga } from './VirtualEvents/index';
import { rootSaga as adminSessionSaga } from './AdminSessions/index';
import { rootSaga as adminWebinarsSaga } from './AdminWebinars/index';
import { rootSaga as adminRecordingsSaga } from './AdminRecordings/index';

const rootSagas = [
  userSaga,
  sessionSaga,
  webinarSaga,
  recordingSaga,
  reportSaga,
  sessionDetailsSaga,
  sessionRegistrantsSaga,
  sessionAttendeesSaga,
  sessionPollsSaga,
  sessionQuestionsSaga,
  sessionSurveysSaga,
  recordingDetailsSaga,
  virtualEventsSaga,
  adminSessionSaga,
  adminWebinarsSaga,
  adminRecordingsSaga
];
export default rootSagas;



// WEBPACK FOOTER //
// ./src/Reducks/RootSagas.js